import { GroupMembershipType } from '@nuso/iam/types';

export function calculateMembershipType(
  member: boolean,
  supervisor: boolean
): GroupMembershipType {
  return (!member && !supervisor) || (member && !supervisor)
    ? 'MEMBER'
    : (!member && supervisor
    ? 'SUPERVISOR'
    : 'MEMBER_AND_SUPERVISOR');
}